import { useEffect } from "react";


type PleasewaitPopupProps = {
    showPopup: boolean;
}

export const PleasewaitPopup = ({ showPopup }: PleasewaitPopupProps) => {
    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10" >
            <div className="flex flex-col items-center rounded-lg bg-white px-6 py-8 shadow-lg">
                <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                <p className="text-gray-800 font-medium">Please wait...</p>
            </div>
        </div >
    )
}